import cx from "classnames";
import React, { type ChangeEvent, useEffect, useState } from "react";
import { InputCount } from "@/appInterface/windows/VoteWindow/NewVote/InputCount";
import style from "./newVoteController.module.css";

type NewVoteControllerProps = {
    name: string;
    description: string;
    count: number;
    onChange: (num: number) => void;
    onInputChange: (num: number) => void;
};

export function NewVoteController({
    name,
    description,
    count,
    onChange,
    onInputChange,
}: NewVoteControllerProps) {
    const [value, setValue] = useState("1");

    const changeCountHandler = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        if (Number(value) > 99) {
            value = "99";
        }
        setValue(value);
        onInputChange(+value);
    };
    const handleBlur = () => {
        if (value === "" || +value <= 0) {
            setValue("1");
            onInputChange(1);
        }
    };

    useEffect(() => {
        setValue(count.toString());
    }, [count]);

    return (
        <div className={cx(style.newVoteController, style.newVoteControllerVote)}>
            <div className={style.newVoteControllerTitle}>{name}</div>
            <div className={style.newVoteControllerSubTitle}>{description}</div>
            <div className={style.newVoteControllerCounterWrapper}>
                <button
                    className={style.newVoteControllerMinus}
                    data-counter="minus"
                    type="button"
                    onClick={() => onChange(-1)}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M5 12C5 11.7348 5.10536 11.4804 5.29289 11.2929C5.48043 11.1054 5.73478 11 6 11H18C18.2652 11 18.5196 11.1054 18.7071 11.2929C18.8946 11.4804 19 11.7348 19 12C19 12.2652 18.8946 12.5196 18.7071 12.7071C18.5196 12.8946 18.2652 13 18 13H6C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12Z"
                            fill="#2C2D32"
                        />
                    </svg>
                </button>
                <div className={style.newVoteControllerCount}>
                    <InputCount value={value} onChange={changeCountHandler} onBlur={handleBlur} />
                </div>
                <button
                    className={style.newVoteControllerPlus}
                    data-counter="plus"
                    type="button"
                    onClick={() => onChange(1)}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="#2C2D32"
                            stroke-width="1.7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
}
